import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { env } from "../utils/env";
import { useAuth } from "../context/AuthContext";

interface Params {
  action: string;
  id: number;
}
export const useExtraAction = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/individual_v2/${params.id}/extra_action/`,
      { action: params.action },
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
